import React, { lazy, Suspense, useEffect, useState } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { MetaPixel } from './components/MetaPixel';
const DeferredLanding = lazy(() => import('./components/DeferredLanding').then(({
  DeferredLanding: Component
}) => ({
  default: Component
})));
export function App() {
  const [loadDeferredContent, setLoadDeferredContent] = useState(false);
  useEffect(() => {
    document.title = 'The Young Inventor Lab™ | 120 Hands-On STEM Builds for Kids Ages 5–12';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'A printable library of 120 hands-on STEM builds for curious kids ages 5–12, using simple household and recycled materials. Five printable volumes, five maker bonuses, instant digital access.');
    const timer = window.setTimeout(() => setLoadDeferredContent(true), 900);
    return () => window.clearTimeout(timer);
  }, []);
  return <div className="w-full bg-ivory text-navy" data-id="element-0" data-mp="6hp9c27i9cj">
      <MetaPixel data-id="element-1" data-mp="56lvdcob3ly" />
      <StickyHeader data-id="element-2" data-mp="7ssnarqpf34" />
      <main data-id="element-3" data-mp="2zld1r8m3ndb0">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="2zlv7cvunj3vl" />
        <Hero data-id="element-5" data-mp="2zn6cp03qwjot" />
        <TrustBar data-id="element-6" data-mp="33mow1rfx4mpj" />
        {loadDeferredContent && <Suspense fallback={<div className="h-10 bg-ivory" aria-hidden="true" data-id="element-8" data-mp="33orhrza1ftog" />} data-id="element-7" data-mp="33n6zb810016y">
            <DeferredLanding data-id="element-9" data-mp="38kqfwel64q22" />
          </Suspense>}
      </main>
    </div>;
}